module.exports = __webpack_public_path__ + "static/media/group.e3b4f418.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/group.svg
// module id = 457
// module chunks = 0